import type { Root } from "mdast";
import type { Plugin } from "unified";

import { $remark } from "@milkdown/kit/utils";

import { withMeta } from "../__internal__";

interface SuperscriptNode {
  type: "superscript";
  children: Array<{ type: "text"; value: string }>;
}

/// A remark plugin to serialize superscript nodes back to Pandoc syntax: ^text^
const remarkSuperscriptStringify: Plugin<[], Root> = function () {
  const data = this.data() as {
    toMarkdownExtensions?: Array<{
      handlers?: Record<
        string,
        (
          node: SuperscriptNode,
          _: unknown,
          state: {
            containerPhrasing: (node: SuperscriptNode, info: unknown) => string;
          },
          info: unknown,
        ) => string
      >;
    }>;
  };

  // Add a handler for superscript nodes
  data.toMarkdownExtensions = data.toMarkdownExtensions || [];
  data.toMarkdownExtensions.push({
    handlers: {
      superscript: (node, _, state, info) => {
        // Get the text content
        const text = state.containerPhrasing(node, info);
        // Return Pandoc superscript syntax: ^text^
        return `^${text}^`;
      },
    },
  });

  return (tree) => tree;
};

export const remarkSuperscriptStringifyPlugin = $remark(
  "remarkSuperscriptStringify",
  () => remarkSuperscriptStringify,
);

withMeta(remarkSuperscriptStringifyPlugin.plugin, {
  displayName: "Remark<remarkSuperscriptStringify>",
  group: "Remark",
});

withMeta(remarkSuperscriptStringifyPlugin.options, {
  displayName: "RemarkConfig<remarkSuperscriptStringify>",
  group: "Remark",
});
